var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { FormControl as ChakraFormControl, FormHelperText as ChakraFormHelperText, FormErrorMessage as ChakraFormErrorMessage, } from "@chakra-ui/react";
import FormLabel from "../FormLabel";
import { Spacing, Size } from "../../core/constants";
import { pick } from "../../core/utils";
export const FormControlSize = pick(Size, ["sm", "md", "lg"]);
const formSizeMap = {
    [FormControlSize.lg]: FormControlSize.md,
    [FormControlSize.md]: FormControlSize.md,
    [FormControlSize.sm]: FormControlSize.sm,
};
const FormControl = forwardRef((_a, ref) => {
    var { className, label, helper, error, children, isInvalid, size = FormControlSize.lg } = _a, rest = __rest(_a, ["className", "label", "helper", "error", "children", "isInvalid", "size"]);
    return (React.createElement(ChakraFormControl, Object.assign({}, rest, { className: className, isInvalid: Boolean(error) || isInvalid, position: "relative", ref: ref }),
        label && React.createElement(FormLabel, { fontSize: formSizeMap[size] }, label),
        children,
        helper && !error && (React.createElement(ChakraFormHelperText, null, helper)),
        typeof error === "string" && (React.createElement(ChakraFormErrorMessage, { p: Spacing[1], position: "relative", top: "-5px" }, error))));
});
FormControl.displayName = "FormControl";
export default FormControl;
//# sourceMappingURL=FormControl.js.map